/**
 * @generated SignedSource<<53596096bb7e81c8cf263fcb969058cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type messageHelpers_user$data = {
  readonly preferences: {
    readonly currency: Currency | null;
  } | null;
  readonly " $fragmentType": "messageHelpers_user";
};
export type messageHelpers_user$key = {
  readonly " $data"?: messageHelpers_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"messageHelpers_user">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "messageHelpers_user"
};

(node as any).hash = "6e27601eb32cd2b02644e342e9089da4";

export default node;
